// 该模块主要用于定义将打包后的 js 文件和菜单复制到目标目录 目标目录 为 定义目录下的 src/main/resources/vue3
export default {
    "merchant": "study-merchant",
}
